import React from 'react';
import { ReactComponent as CityIconSvg } from './icon_cities.svg';
import { ReactComponent as MonitoringIconSvg } from './monitoring.svg';
import { ReactComponent as ParnerIconSvg } from './icon_partner_com_blue.svg';
import { ReactComponent as TicketIconSvg } from './icon_tickets.svg';
import { ReactComponent as PdfIconSvg } from './icon_pdf.svg';
import { ReactComponent as BookingIconSvg } from './icon_booking.svg';
import { ReactComponent as TicketConflictSvg } from './icon_ticket_conflict.svg';
import { ReactComponent as RoleSvg } from './roles.svg';
import { ReactComponent as GlobalSvg } from './icon_global.svg';
import { ReactComponent as ReportSvg } from './report.svg';
import { ReactComponent as BusReportSvg } from './icon_bus_report.svg';
import { ReactComponent as TVSvg } from './icon_tv.svg';
import { ReactComponent as HomeSvg } from './icon_home.svg';
import { ReactComponent as SaleReportSvg } from './icon_salereport.svg';
import { ReactComponent as AdvertisingSvg } from './icon_advertising.svg';
import { ReactComponent as ReconciliationSvg } from './icon_reconciliation.svg';
import { ReactComponent as ShipmentSvg } from './icon_shipments_blue.svg';

export const CityIcon = (props: React.SVGProps<any>) => <CityIconSvg className="entity-icon" {...props} />;

export const MonitoringIcon = (props: React.SVGProps<any>) => <MonitoringIconSvg className="entity-icon" {...props} />;

export const ConfigurationIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon-configuration.png')} alt="configuration" className="entity-icon" {...props} />
);

export const ManageUsersIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon-manage-users.png')} alt="manage-users" className="entity-icon" {...props} />
);

export const OperationsIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon-operations.png')} alt="operations" className="entity-icon" {...props} />
);

export const MembersIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_member.png')} alt="operations" className="entity-icon" {...props} />
);

export const AccessControlIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./access-control.png')} alt="access-control" className="entity-icon" {...props} />
);

export const ParnerIcon = (props: React.SVGProps<any>) => <ParnerIconSvg className="entity-icon" {...props} />;

export const PassengerIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_passenger.png')} alt="passenger" className="entity-icon" {...props} />
);
export const CompanyIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_vendor.png')} alt="company" className="entity-icon" {...props} />
);

export const PlanIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_plan.png')} alt="plan" className="entity-icon" {...props} />
);

export const ServiceIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_service.png')} alt="company" className="entity-icon" {...props} />
);
export const SoftwareComponentIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon-software.png')} alt="company" className="entity-icon" {...props} />
);
export const GrowingIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_growing.png')} alt="growing" className="entity-icon" {...props} />
);

export const ManagementIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_management.png')} alt="management" className="entity-icon" {...props} />
);

export const SellingIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_selling.png')} alt="selling" className="entity-icon" {...props} />
);
export const StaffIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_staff.png')} alt="staff" className="entity-icon" {...props} />
);
export const TarrifIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_tarrif.png')} alt="staff" className="entity-icon" {...props} />
);
export const DiscountIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_discount.png')} alt="staff" className="entity-icon" {...props} />
);
export const StationIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_station.png')} alt="account" className="entity-icon" {...props} />
);
export const NotificationIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_notification.png')} alt="icon" className="entity-icon" {...props} />
);
export const SettingIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_setting.png')} alt="icon" className="entity-icon" {...props} />
);
export const SubscriptionIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_subscription.png')} alt="icon" className="entity-icon" {...props} />
);
export const FleetIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_fleet.png')} alt="icon" className="entity-icon" {...props} />
);
export const BusIcon = (props: React.ImgHTMLAttributes<any>) => <img src={require('./icon_bus.png')} alt="icon" className="entity-icon" {...props} />;
export const TemplateIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_templates.png')} alt="icon" className="entity-icon" {...props} />
);

export const RouteAndTripIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_route-trip.png')} alt="icon" className="entity-icon" {...props} />
);

export const TripCalendarIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./trip_calendar.png')} alt="trip" className="entity-icon" {...props} />
);
export const TripDetailIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon_tripdetail.png')} alt="trip" className="entity-icon" {...props} />
);
export const CounterIcon = (props: React.ImgHTMLAttributes<any>) => (
  <img src={require('./icon-counter.png')} alt="counter" className="entity-icon" style={{ padding: 2 }} {...props} />
);
export const TicketIcon = (props: React.SVGProps<any>) => <TicketIconSvg className="entity-icon" {...props} />;

export const Pdf = (props: React.SVGProps<any>) => <PdfIconSvg className="entity-icon" {...props} />;

export const BookingIcon = (props: React.SVGProps<any>) => <BookingIconSvg className="entity-icon" {...props} />;

export const TicketConflictIcon = (props: React.SVGProps<any>) => <TicketConflictSvg className="entity-icon" {...props} />;

export const RoleIcon = (props: React.SVGProps<any>) => <RoleSvg className="entity-icon" {...props} />;

export const GlobalICon = (props: React.SVGProps<any>) => <GlobalSvg className="entity-icon" {...props} />;

export const ReportIcon = (props: React.SVGProps<any>) => <ReportSvg className="entity-icon" {...props} />;

export const BusReportIcon = (props: React.SVGProps<any>) => <BusReportSvg className="entity-icon" {...props} />;
export const TvIcon = (props: React.SVGProps<any>) => <TVSvg className="entity-icon" {...props} />;
export const HomeIcon = (props: React.SVGProps<any>) => <HomeSvg className="entity-icon" {...props} />;
export const SaleReportIcon = (props: React.SVGProps<any>) => <SaleReportSvg className="entity-icon" {...props} />;

export const AdvertisingIcon = (props: React.SVGProps<any>) => <AdvertisingSvg className="entity-icon" {...props} />;

export const ReconciliationIcon = (props: React.SVGProps<any>) => <ReconciliationSvg className="entity-icon" {...props} />;

export const ShipmentIcon = (props: React.SVGProps<any>) => <ShipmentSvg className="entity-icon" {...props} />;
